import { FC } from 'react';

import UserIcon from '@/assets/user.svg?react';

import ErrorMessage from '@/components/ui/ErrorMessage';
import { FormControl, FormField, FormItem } from '@/components/ui/Form';
import Select from '@/components/ui/Select/Select';

import SectionHeader from './SectionHeader';
import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const CO_OWNERS_COUNT_NAME = 'co_owners_count';

const CO_OWNERS_OPTIONS = Array.from({ length: 10 }, (_, i) => ({
  value: String(i + 1),
  label: String(i + 1),
}));

interface Props {
  name?: string;
}

const SelectCoOwnersCount: FC<Props> = ({ name = CO_OWNERS_COUNT_NAME }) => {
  const { i18n } = useLingui();
  const { control, trigger } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        validate: (value) =>
          !!value || i18n.t('Wskaż liczbę współwłaścicieli działki'),
      }}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <FormItem className="rounded-md bg-gray-200 p-[14px] md:p-6">
          <SectionHeader
            icon={UserIcon}
            label={i18n.t('Ilu jest współwłaścicieli działki?')}
          />
          <FormControl>
            <Select
              placeholder={i18n.t('Wybierz od 1 do 10')}
              value={value}
              onChange={(v: string) => {
                onChange(v);
                trigger(name);
              }}
              options={CO_OWNERS_OPTIONS}
              error={error?.message}
              success={!error && !!value}
              className="caption-large"
              valueClassName="text-sm leading-[22px] font-normal lg:font-default lg:text-[15px] lg:leading-6"
            />
          </FormControl>
          {error && (
            <ErrorMessage errorMessage={error.message} className="!mt-1" />
          )}
        </FormItem>
      )}
    />
  );
};

export default SelectCoOwnersCount;
